<style scoped lang="less">
.no-data {
  text-align: center;
  padding: 30px 0;
}
#csv {
  display: none;
}
.content-table{
  border: 1px solid #EBEEF5;
  .table-list{
    min-height: 36px;
    border-bottom: 1px solid #EBEEF5;
    line-height: 36px;
    &:nth-child(even){
     background-color: #F5F7FA; 
    }
    &:last-child{
      border-bottom: none;
    }
    .table-list-right{
      border-right: 1px solid #EBEEF5;
      position: relative;
      right: -1px;
      // margin-left: 1px;
    }
    .table-list-left{
      border-left: 1px solid #EBEEF5;
    }
  }
}

</style>
<template>
  <div>
    <div class="page-content">
      <div class="title">{{ title ? title : "基本信息" }}</div>
      <div class="content">
        <div class="content-table" v-if="list.length">
          <div v-for="(item, key) in list" :key="key" class="table-list">
            <el-row :gutter="10" v-if="!isDown||item.attribute!='file_link'">
              <el-col :span="left ? left : 4" class="text-right table-list-right">{{ item.name }}：</el-col>
              <el-col :span="right ? right : 20" class="table-list-left" :class="{ 'font-color-no': !item.value }">
                <div v-if="item.type" class="font-color-theme cursor-pointer">{{ item.value }}</div>
                <div v-else>{{ item.value ? item.value : "暂无" }}</div>
              </el-col>
            </el-row>
          </div>
          <div v-if="isDown&&list.length" class="table-list">
            <el-row :gutter="10">
              <el-col :span="4" class="text-right table-list-right">操作：</el-col>
              <el-col :span="20">
                <span class="font-color-theme cursor-pointer" @click="downloadNuclide">下载</span>
              </el-col>
            </el-row>
          </div>
        </div>
        

        <div v-if="!list.length" class="no-data font-color-no">暂无数据</div>
        <a id="csv"></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "informationList",
  props: {
    list: Array,
    title: String,
    right: Number,
    left: Number,
    isDown: Boolean,
    isDownId: Number,
  },
  data() {
    return {};
  },
  computed: {
    // id: function () {
    //   return this.$route.params.id || ""; //自动站id
    // },
  },
  //   props: ['noDataObj'],
  methods: {
    //下载
    downloadNuclide() {
      this.$$http("downloadNuclide", {
        id: this.isDownId,
      })
        .then((results) => {
          if (results.data && results.status == 200) {
            // console.log("下载", results.data);
            // let csv = "data" + ".csv";
            // let anchor = document.getElementById("csv");
            // anchor.href =
            //   "data:text/csv;charset=utf-8," + encodeURIComponent(results.data);
            // anchor.target = "_blank";
            // anchor.download = csv;
            // anchor.click();
            // this.$message.success("下载成功");
            let downName = "文件.spe";
            for (let i in this.list) {
              if (this.list[i].attribute == "file_name") {
                downName = this.list[i].value;
              }
            }
            let anchor = document.getElementById("csv");
            anchor.href =
              "data:text/csv;charset=utf-8," + encodeURIComponent(results.data);
            anchor.target = "_blank";
            anchor.download = downName;
            anchor.click();
            this.$message.success("下载成功");
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "下载失败"
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/informationList.vue